import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaStar, FaRegHeart, FaShoppingCart } from 'react-icons/fa';

const Featuredproduct = () => {
  const products = [
    {
      id: 1,
      name: 'Wireless Bluetooth Headphones',
      price: 129.99,
      discount: 159.99,
      rating: 4.5,
      image: 'https://via.placeholder.com/300x300?text=Headphones',
      isNew: true,
    },
    {
      id: 2,
      name: 'Smart Watch Pro',
      price: 199.99,
      discount: 249.99,
      rating: 4.2,
      image: 'https://via.placeholder.com/300x300?text=Smart+Watch',
      isNew: false,
    },
    {
      id: 3,
      name: 'Ultra HD 4K Camera',
      price: 899.99,
      discount: 999.99,
      rating: 4.8,
      image: 'https://via.placeholder.com/300x300?text=Camera',
      isNew: true,
    },
    {
      id: 4,
      name: 'Wireless Charging Pad',
      price: 49.99,
      discount: 59.99,
      rating: 4.0,
      image: 'https://via.placeholder.com/300x300?text=Charger',
      isNew: false,
    },
  ];

  return (
    <section className="featured-products py-5 bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-6 fw-bold">Featured <span style={{
            background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            display: "inline-flex",
            alignItems: "center",
            textDecoration: "none",
            marginTop: "auto",
          }}>Products</span> </h2>
          <p className="text-muted">Discover our most popular items</p>
        </div>
        
        <Row className="g-4">
          {products.map((product) => (
            <Col key={product.id} lg={3} md={6}>
              <Card className="h-100 border-0 shadow-sm hover-shadow transition-all">
                <div className="position-relative">
                  <Card.Img variant="top" src={product.image} alt={product.name} />
                  {product.isNew && (
                    <span className="badge bg-danger position-absolute top-0 start-0 m-2">New</span>
                  )}
                  <button className="btn btn-sm btn-light position-absolute top-0 end-0 m-2 rounded-circle">
                    <FaRegHeart />
                  </button>
                </div>
                <Card.Body className="d-flex flex-column">
                  <div className="mb-2">
                    <span className="text-warning">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} className={i < Math.floor(product.rating) ? 'fas' : 'far'} />
                      ))}
                    </span>
                    <span className="text-muted ms-2">({product.rating})</span>
                  </div>
                  <Card.Title className="h6 mb-2">{product.name}</Card.Title>
                  <div className="mt-auto">
                    <div className="d-flex align-items-center mb-2">
                      <span className="h5 mb-0 text-dark">${product.price}</span>
                      {product.discount && (
                        <span className="text-muted text-decoration-line-through ms-2">
                          ${product.discount}
                        </span>
                      )}
                    </div>
                    <Button variant="dark" className="w-100">
                      <FaShoppingCart className="me-2" /> Explore Now
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        
        <div className="text-center mt-5">
          <Button variant="outline-dark" size="lg">View All Products</Button>
        </div>
      </Container>
    </section>
  );
};

export default Featuredproduct;